import {
  GridCellParams,
  GridFilterItem,
  GridFilterModel,
  GridFilterOperator,
  GridLinkOperator
} from '@mui/x-data-grid-pro';

export const stringArrayIntersectionOperator: GridFilterOperator = {
  label: 'Intersects',
  value: 'intersects',
  getApplyFilterFn:
    (filterItem: GridFilterItem) =>
    (params: GridCellParams): boolean => {
      if (!params.value) return false;
      const cellValue = params.value.toString(); // make sure it’s a string
      const filterValues: string[] = Array.isArray(filterItem.value)
        ? filterItem.value
        : [filterItem.value];
      return filterValues.includes(cellValue);
    }
};
const getActivityStatusFilter = (activityStatus: string[]) => {
  return [
    {
      id: 0,
      columnField: 'Status',
      operatorValue: 'intersects',
      value: activityStatus
    }
  ];
};

export const getFilterModel = ({
  activityStatus
}: {
  activityStatus?: string[];
}): GridFilterModel => {
  let filters = [];
  if (activityStatus && activityStatus?.length > 0) {
    filters.push(...getActivityStatusFilter(activityStatus));
  }

  return {
    items: filters,
    linkOperator: GridLinkOperator.And
  };
};
